import {CreateEditSystemAgent, SystemAgentDomain, SystemAgentUser, UserId} from "../Types";
import {CURRENT_REGION} from "../utils/region";
import jsonApi from "./jsonApi";
import {invalidateQueries, q} from "../state";

export async function list(domain: SystemAgentDomain) {
  return await jsonApi.get<SystemAgentUser[]>(`/region/${CURRENT_REGION}/api/system_agents/domain/${domain}`);
}

export async function listAll() {
  return await jsonApi.get<SystemAgentUser[]>(`/region/${CURRENT_REGION}/api/system_agents`);
}

export async function listDefault() {
  return await jsonApi.get<SystemAgentUser[]>(`/region/${CURRENT_REGION}/api/system_agents/default`);
}

export async function create(agent: CreateEditSystemAgent) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/system_agents`, agent);
  await invalidateQueries([q.systemAgentsByDomain.filter(), q.systemAgents.filter()]);
  return res;
}
export async function update(agent: CreateEditSystemAgent, agentId: UserId) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/system_agents/${agentId}`, agent);
  await invalidateQueries([q.systemAgentsByDomain.filter(), q.systemAgents.filter()]);
  return res;
}

export async function delete_(agentId: UserId) {
  const res = await jsonApi.delete_<"ok">(`/region/${CURRENT_REGION}/api/system_agents/${agentId}`);
  await invalidateQueries([q.systemAgentsByDomain.filter(), q.systemAgents.filter()]);
  return res;
}
